import { render, staticRenderFns } from "./TaxDocumentChecking.vue?vue&type=template&id=65fe8e89&scoped=true"
import script from "./TaxDocumentChecking.vue?vue&type=script&lang=js"
export * from "./TaxDocumentChecking.vue?vue&type=script&lang=js"
import style0 from "./TaxDocumentChecking.vue?vue&type=style&index=0&id=65fe8e89&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fe8e89",
  null
  
)

export default component.exports